import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { FormattedMessage } from "react-intl";

import "./style.scss";

function Text({
  id,
  color,
  size,
  weight,
  inline,
  title,
  truncate,
  breakRow,
  center,
  italic,
  unselectable,
  className,
  children
}) {

  const classes = classnames("text", className, {
    "text--inline": inline,
    "text--truncate": truncate,
    "text--break": breakRow,
    "text--center": center,
    "text--italic": italic,
    [`text--${color}`]: color !== "inherit",
    [`text--${size}`]: size !== "normal",
    [`text--${weight}`]: weight !== "normal",
    "text--unselectable": unselectable,
  });

  const content = id !== null
    ? <FormattedMessage id={id} />
    : children;

  return (
    <div className={classes} title={title}>
      {content}
    </div>
  );
};

Text.defaultProps = {
  id: null,
  inline: false,
  title: null,
  color: "inherit",
  size: "normal",
  weight: "normal",
  className: null,
  truncate: false,
  breakRow: false,
  unselectable: false,
};

Text.propTypes = {
  id: PropTypes.string,
  inline: PropTypes.bool,
  title: PropTypes.string,
  className: PropTypes.string,
  truncate: PropTypes.bool,
  breakRow: PropTypes.bool,
  center: PropTypes.bool,
  italic: PropTypes.bool,
  unselectable: PropTypes.bool,
  color: PropTypes.oneOf(["inherit", "text", "primary", "secondary", "muted", "error", "warning", "success", "white", "wura", "admin", "premium"]),
  size: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "normal", "small", "tiny"]),
  weight: PropTypes.oneOf(["light", "normal", "bold", "black"]),
};

export default Text;
